interface Option {
  type: string;
  label: string;
  value: string;
}

export const KEYWORD_OPTIONS: Option[] = [
  { type: 'free', label: '求人掲載内容すべて', value: '1' },
  { type: 'company', label: '社名', value: '2' },
  { type: 'job', label: '職種名', value: '3' },
  { type: 'location', label: '勤務地', value: '4' },
  { type: 'skill', label: '経験・スキル', value: '5' },
];

export const DEFAULT_KEYWORD_OPTION = KEYWORD_OPTIONS[0];
